"use client";
import React, { ReactNode } from "react";

import LoadingWithFooter from "components/LoadingWithFooter";
import { Maintenance } from "components/Maintenance";
import { useFirebaseRecoilValue } from "hooks/useFirebaseRecoilValue";

const AppConditionalDisplayWrapper = ({ children }: { children: ReactNode }) => {
  const { remoteConfig, appReady, authReady } = useFirebaseRecoilValue();

  // メンテナンスモードかどうか
  if (remoteConfig.isMaintenanceMode) return <Maintenance maintenanceDateString={remoteConfig.maintenanceDateString} />;

  // firebaseの読み込みが終了しているかどうか
  if (!appReady || !authReady) return <LoadingWithFooter />;

  return <>{children}</>;
};

export default AppConditionalDisplayWrapper;
